<ion-slides
  [options]="slideOpts"
  (ionSlideNextEnd)="loadNext()"
  (ionSlidePrevEnd)="loadPrev()"
>
  <ion-slide *ngFor="let week of calendarWeekList">
    <div class="calendar-container">
      <div
        tappable
        [ngClass]="{
          'calendar-item': true,
          'calendar-item-selected': compareDate(date, selectedDate),
          'calendar-item-today': compareDate(date, today),
          'calendar-item-today-selected':
            compareDate(date, selectedDate) && compareDate(date, today)
        }"
        *ngFor="let date of week"
        (click)="selectDate(date)"
      >
        <div style="font-size: 12px">{{ DayOfWeek[date.getDay()] }}</div>
        <div class="calendar-date-number">{{ date.getDate() }}</div>
      </div>
    </div>
  </ion-slide>
</ion-slides>
